<template>
  <div>
    <form @submit.stop.prevent>
      <div class="alert alert-success">
        <span>纸张：xxxgxxx纸</span><br/>
        <span>装订方式：胶装，蝴蝶对裱，</span><br/>
        <span>打印目录：拼板文件存放位置</span><br/>
        <span>镀膜：亮膜/哑膜/无膜</span><br/>
      </div>
      <div v-for="product in products" :key="product.product_code" :id="'product-' + product.product_code">
        <h4>{{product.name}} / {{product.product_code}}</h4>
        <div class="form-group row">
          <label class="col-2 col-form-label">纸张</label>
          <div class="col">
            <input class="form-control" type="text" name="paper" :value="product.paper">
          </div>

          <label class="col-2 col-form-label">装订方式</label>
          <div class="col">
            <input class="form-control" type="text" name="binding_style" :value="product.binding_style">
          </div>
        </div>

        <div class="form-group row">
          <label class="col-2 col-form-label">类型</label>
          <div class="col">
            <select class="custom-select" :value="product.product_type" disabled>
              <option value="inner">内页</option>
              <option value="cover">封面</option>
              <option value="other">其他</option>
            </select>
          </div>
          <label class="col-2 col-form-label">打印目录</label>
          <div class="col">
            <input class="form-control" type="text" name="printer_folder" :value="product.printer_folder">
          </div>
        </div>

        <div class="row form-group">
          <label class="col-2 col-form-label">镀膜</label>
          <div class="col">
            <input class="form-control" type="text" name="coating" :value="product.coating">
          </div>
          <label class="col-2 col-form-label">双面/单面打印</label>
          <div class="col">
            <select class="custom-select" name="duplex_printing" :value="product.duplex_printing">
              <option :value="false">单面打印</option>
              <option :value="true">双面打印</option>
            </select>
          </div>
        </div>
        <div class="row form-group">
          <label class="col-2 col-form-label">拼板模板</label>
          <div class="col-4">
            <input class="form-control" type="text" :value="product.template || '默认'" readonly>
          </div>
          <div class="col">
            <button type="submit" class="btn btn-primary" @click="updateProduct(product, $event)">提交</button>
          </div>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
function loadData () {
  if (!this.mainProductCode) {
    return
  }

  this.$http.get(`/api/products?parent_product_code=${this.mainProductCode}`).then(response => {
    this.products = response.data.data
  })
}

function updateProduct (product, event) {
  let button = event.target
  let data = {}
  let keys = ['paper', 'binding_style', 'printer_folder', 'coating']

  let root = document.getElementById('product-' + product.product_code)
  for (let key of keys) {
    data[key] = root.querySelector(`[name="${key}"]`).value
  }
  // 单面双面打印
  let duplex_printing = root.querySelector('[name="duplex_printing"]').value
  data.duplex_printing = duplex_printing === 'true' ? true : false

  // confirm duplex_printing
  if (data.duplex_printing !== product.duplex_printing) {
    let result = confirm('您希望修改单面/双面打印类型， 请确认')
    if (!result) {
      return
    } 
  }

  this.$http.put(`/api/products/${product.product_code}`, data).then(response => {
  })
}

export default {
  name: "editProduct",
  props: ['mainProductCode'],
  data () {
    return {
      products: []
    }
  },
  methods: {
    loadData,
    updateProduct
  },
  mounted () {
    this.products = []
    this.loadData()
  }
}
</script>
